import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.05 18.275a2 2 0 0 1-.775-.737A2 2 0 0 1 5 16.5v-4.8l-2.4-1.325A.97.97 0 0 1 2.2 10a1 1 0 0 1-.125-.5q0-.275.125-.5a.97.97 0 0 1 .4-.375l8.45-4.6a1.9 1.9 0 0 1 1.438-.188q.237.064.462.188l9.525 5.2a.9.9 0 0 1 .387.363q.138.238.138.512v6.4a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287.97.97 0 0 1-.712-.287A.97.97 0 0 1 21 16.5v-5.9l-2 1.1v4.8q0 .576-.275 1.038a2 2 0 0 1-.775.737l-5 2.7a1.9 1.9 0 0 1-1.438.188 2 2 0 0 1-.462-.188zM12 13.2l6.85-3.7L12 5.8 5.15 9.5zm0 6.025 5-2.7V12.75l-4.025 2.225a2.05 2.05 0 0 1-1.475.188 2 2 0 0 1-.475-.188L7 12.75v3.775z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }